import { ApplicationState } from '@/store';
import React, { CSSProperties, ReactNode } from 'react';
import Modal from 'react-bootstrap/esm/Modal';
import { useSelector } from 'react-redux';
import './style.scss';

export interface StudentConfirmDialogPropsType {
    show: boolean;
    content?: string | JSX.Element;
    contentStyle?: CSSProperties;
    leftClick?: () => void;
    title?: string;
    titleStyle?: CSSProperties;
    rightClick: () => void;
    leftButtonTitle?: string;
    rightButtonTitle?: string;
    rightButtonStyle?: CSSProperties;
    icon?: string | ReactNode;
    useMdi?: boolean;
    iconStyle?: CSSProperties;
    hideIcon?: boolean;
    onExited?: () => void;
}

const StudentConfirmDialog = (props: StudentConfirmDialogPropsType) => {
    const { data: strings } = useSelector((state: ApplicationState) => state.locale);

    const {
        show,
        content,
        contentStyle,
        title,
        titleStyle,
        leftClick,
        rightClick,
        leftButtonTitle = strings.YES,
        rightButtonTitle = strings.NO,
        rightButtonStyle,
        icon,
        iconStyle,
        onExited,
        useMdi,
    } = props;

    return (
        <Modal aria-labelledby="contained-modal-title-vcenter" centered className="student-confirm-dialog" onExited={onExited} show={show}>
            <Modal.Body>
                <div className="container">
                    {useMdi && !!icon && icon}

                    {!useMdi && icon && (
                        <i className="material-icons-outlined align-middle" style={iconStyle}>
                            {icon}
                        </i>
                    )}

                    {title && (
                        <span className="title" style={titleStyle}>
                            {title}
                        </span>
                    )}
                    {content && (
                        <span className="content" style={contentStyle}>
                            {content}
                        </span>
                    )}
                    <div className="buttons">
                        {leftClick && (
                            <button className="btn left" data-dismiss="modal" onClick={leftClick} type="button">
                                {leftButtonTitle}
                            </button>
                        )}
                        <button className="btn right" data-dismiss="modal" onClick={rightClick} style={rightButtonStyle} type="button">
                            {rightButtonTitle}
                        </button>
                    </div>
                </div>
            </Modal.Body>
        </Modal>
    );
};

export default StudentConfirmDialog;
